// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ab9E","signatureBlock":"Footer_signatureBlock__3vFQN","signature":"Footer_signature__2NA6u"};